export default __webpack_public_path__ + "static/media/logo.07283ac3.png";